export const getProjectType = (projectType: string) => {
  switch (true) {
    case projectType === 'workspace':
      return 'Document Project';
    case projectType === 'information_request':
      return 'Questionnaire Project';
  }
};
